(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var youtubeDomain = "https://www.youtube-nocookie.com";
var ytImgDomain = "https://i.ytimg.com/vi";
var webPImgDomain = "https://i.ytimg.com/vi_webp";
var trinidad = isServer ? require('trinidad-core').core : {};
var _ref = isServer ? trinidad.components.require('utils', 'get-json-ld') : svs.utils,
  getJsonLDString = _ref.getJsonLDString;
function loadVideo(options, callback) {
  if (!options) {
    callback('Options object is required');
    return;
  }
  if (!options.type || options.type !== 'youtube') {
    callback('Unsupported media source type');
    return;
  }
  if (!options.videoId) {
    callback('Missing videoId');
    return;
  }
  var videoId = options.videoId,
    height = options.height,
    width = options.width,
    title = options.title,
    type = options.type,
    name = options.name,
    publishedAt = options.publishedAt;
  var videoSrc = "".concat(youtubeDomain, "/embed/").concat(videoId, "?rel=0");
  var thumbnailUrl = "".concat(ytImgDomain, "/").concat(videoId);
  var webpThumbnailUrl = "".concat(webPImgDomain, "/").concat(videoId);
  var model = {
    name: name || '100',
    type: type || 'youtube',
    src: videoSrc,
    publishedAt: publishedAt,
    heightPercent: height && width ? height / width * 100 : undefined,
    videoId: videoId,
    thumbnailUrl: thumbnailUrl,
    title: title || 'Svenska Spel Video',
    height: height || '1280',
    width: width || '720',
    webpThumbnailUrl: webpThumbnailUrl
  };
  var jsonLDTags = getJsonLDString({
    duration: options === null || options === void 0 ? void 0 : options.duration,
    description: options === null || options === void 0 ? void 0 : options.description,
    uploadDate: publishedAt,
    name: model.title,
    thumbnailUrl: thumbnailUrl
  });
  callback(null, _objectSpread(_objectSpread({}, model), {}, {
    jsonLDTags: jsonLDTags
  }));
}
if (isServer) {
  module.exports = {
    loadVideo: loadVideo
  };
} else {
  svs.components.youtube_video.utils = {
    loadVideo: loadVideo
  };
}

 })(window);